<template>
  <component
    :is="currentComponent"
    v-bind="currentProps"
    @close="$emit('close')"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
  import type { ConcreteComponent } from 'vue';

  interface IProps {
    isOpen: boolean;
    maskClosable?: boolean;
    maxWidth?: string; // PopUp
    minHeight?: string; // PopUp
    hasSpace?: boolean; // PopUp
    direction?: 'right' | 'bottom'; // Drawer
  }

  const props = withDefaults(defineProps<IProps>(), {
    maskClosable: true,
    maxWidth: '600px',
    minHeight: '300px',
    hasSpace: true,
    direction: 'bottom',
  });

  defineEmits<{
    (e: 'close'): void;
  }>();

  const { isMobile } = useScreen();

  const TheDrawer = resolveComponent('TheDrawer');
  const ThePopUp = resolveComponent('ThePopUp');

  const currentComponent = computed((): string | ConcreteComponent => {
    return isMobile.value ? TheDrawer : ThePopUp;
  });

  const currentProps = computed(() => {
    const baseProps = {
      isOpen: props.isOpen,
      maskClosable: props.maskClosable,
    };

    if (isMobile.value) {
      return {
        ...baseProps,
        direction: props.direction,
      };
    } else {
      return {
        ...baseProps,
        maxWidth: props.maxWidth,
        minHeight: props.minHeight,
        hasSpace: props.hasSpace,
      };
    }
  });
</script>
